module.exports = __webpack_public_path__ + "static/media/placeholder.83304e60.jpg";